module.exports = __webpack_public_path__ + "static/img/trainingbenefit4.8cedf7d4.png";